import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.7.4_eslint@8.51.0_typescript@5.2.2/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}